<template>
  <Modal :open.sync="open" size="small" :support-links="true">
    <div class="dwp-space-y-4" ref="signIn">
      <template v-if="forgotPassword">
        <div>
          <div class="dwp-font-medium dwp-text-xl">Reset Your Password</div>
          <div class="dwp-text-gray-600 dwp-text-sm">Enter your email to get a password reset link.</div>
        </div>
        <Flash v-if="error">{{ error }}</Flash>
        <Flash type="success" v-if="success">Sent! Please check your inbox.</Flash>
        <form @submit.prevent="reset" class="dwp-space-y-5">
          <TextInput
            label="Email"
            placeholder="Email Address"
            v-model="form.email"
            type="email"
            required
          />
          <div class="dwp-flex dwp-justify-between dwp-items-center">
            <VButton type="submit" button-type="submit">Reset Password</VButton>
            <div
              class="dwp-text-xs dwp-text-gray-500 dwp-cursor-pointer"
              @click.prevent="forgotPassword  = false"
            >Sign In</div>
          </div>
        </form>
      </template>
      <template v-else>
        <div>
          <div class="dwp-font-medium dwp-text-xl">Sign In</div>
          <div class="dwp-text-gray-600 dwp-text-sm">Sign into your DocketWP account.</div>
        </div>
        <Flash v-if="error">{{ error }}</Flash>
        <form @submit.prevent="submit" class="dwp-space-y-5">
          <TextInput
            label="Email"
            placeholder="Email Address"
            v-model="form.email"
            type="email"
            required
          />
          <TextInput
            label="Password"
            placeholder="Password"
            v-model="form.password"
            type="password"
            required
          />
          <div class="dwp-flex dwp-justify-between dwp-items-center">
            <VButton type="submit" button-type="submit">Sign In</VButton>
            <div
              class="dwp-text-xs dwp-text-gray-500 dwp-cursor-pointer"
              @click.prevent="forgotPassword  = true"
            >Forgot your password?</div>
          </div>
        </form>
      </template>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/ui/Modal.vue";
import TextInput from "@/components/ui/TextInput.vue";
import VButton from "@/components/ui/VButton.vue";
import Logo from "@/components/illustrations/Logo.vue";
import Flash from "@/components/ui/Flash.vue";
import { sync, call } from "vuex-pathify";
import { Firebase } from "@/services/firebase";

export default {
  components: {
    Modal,
    TextInput,
    Flash,
    Logo,
    VButton
  },
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      error: "",
      success: false,
      forgotPassword: ""
    };
  },

  computed: {
    open: sync("ui/open")
  },

  watch: {
    forgotPassword() {
      this.error = "";
      this.success = false;
    }
  },

  methods: {
    ...call("user", ["authenticate"]),
    async submit() {
      this.error = "";
      try {
        let signedIn = await this.authenticate({
          email: this.form.email,
          password: this.form.password
        });
      } catch (error) {
        this.handleError(error);
      }
    },

    async reset() {
      this.error = "";
      try {
        await Firebase.auth().sendPasswordResetEmail(this.form.email);
        this.form = {
          email: "",
          password: ""
        };
        this.success = true;
      } catch (error) {
        this.handleError(error);
      }
    },

    handleError(error) {
      switch (error?.code) {
        case "auth/user-not-found":
          this.error =
            "This email address does not exist. Please double check this is the email address used on your DocketWP account.";
          break;
        case "auth/wrong-password":
          this.error = "This password is incorrect.";
          break;
        default:
          this.error = "Something went wrong.";
          break;
      }
    }
  }
};
</script>